import formatDate from "./fomatDate";

function formatDate2(date:any) {
    
    
        let tab = []
        tab=(formatDate(date)).split("/");
        let tab2=[]
        tab2=tab[2].split("T")
        let datearret=tab2[0]+'-'+tab[1]+'-'+tab[0]+'T'+tab2[1]
    
    return (
        datearret
    );
  }
  
  export default formatDate2;